<template>
  <g fill="none" fill-rule="evenodd">
    <path
      d="M0 2h18a2 2 0 110 4H0V2zm0 8h22a2 2 0 110 4H0v-4zm0 8h14a2 2 0 110 4H0v-4z"
      fill="#067BF0"
      fill-rule="nonzero"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BurgerMenuIcon",
});
</script>
